/**
 * HomePage V2 content — aligned with HomePage.jsx baseline + concept image.
 * TODO: CMS/API when available.
 */

const IMG = {
  heroBanner: "/static/img/IMAGES/BANNERS/homepage_banner_mobile.png",
  story: "/static/img/AdobeStock_179076750.jpeg",
  storyAlt: "/static/img/lau-55.png",
  event: "/static/img/AdobeStock_185103610.jpeg",
  program: "/static/img/AdobeStock_440987972.jpeg",
  mlistBanner: "/static/img/m_list_banner_mobile.png",
  founderAbout: "/static/img/AdobeStock_179076750.jpeg",
  founderFeatured: "/static/img/AdobeStock_179076750.jpeg",
};

export const homePageV2Hero = {
  title: "Nailing this mama-thing together",
  cta: { label: "Join", to: "/twentytwentysix/join" },
  image: IMG.heroBanner,
};

export const homePageV2Welcome = {
  eyebrow: "WELCOME TO THE MAMAHOOD",
  headline: "Where we mamas go to lift each other up & be supported ourselves",
  body:
    "We offer FREE support like chat groups, articles, podcasts, events and resources for Bay Area, California mamas.",
  regions: [
    { label: "San Francisco Bay Area", to: "/twentytwentysix/events", color: "coral" },
    { label: "Sacramento Valley", to: "/twentytwentysix/events", color: "mustard" },
    { label: "LA County", to: "/twentytwentysix/events", color: "pink" },
  ],
};

export const homePageV2Happening = [
  {
    title: "Virtual Community",
    text: "We've got 20 topic-specific chat groups waiting for you.",
    icon: "💬",
    color: "salmon",
    to: "/twentytwentysix/resources",
  },
  {
    title: "In Person Events",
    text: "Check our calendar to find out where mamas are meeting up.",
    icon: "📅",
    color: "coral",
    to: "/twentytwentysix/events",
  },
  {
    title: "Inspiration",
    text: "Helpful mothering articles by moms for mom.",
    icon: "💡",
    color: "mustard",
    to: "/twentytwentysix/resources",
  },
  {
    title: "Podcasts",
    text: "Authentic conversations with working moms.",
    icon: "🎙️",
    color: "mint",
    to: "/twentytwentysix/podcasts",
  },
  {
    title: "Resources",
    text: "We curate an exciting list of mama-products and services.",
    icon: "M",
    color: "teal",
    to: "/twentytwentysix/mlist",
  },
];

export const homePageV2Membership = {
  tiers: [
    {
      logo: "M",
      title: "For All Moms",
      bodyHtml: true,
      body: "Starting with our FREE membership, you can always upgrade for more resources.",
      cta: { label: "Become a Member Today", to: "/twentytwentysix/join" },
    },
    {
      logo: "TMC",
      logoSmall: true,
      title: "For Women+ Entrepreneurs",
      bodyHtml: true,
      body: "Join 800+ women+ entrepreneurs building sustainable businesses.",
      cta: { label: "Join The Mamahood Collective", to: "/twentytwentysix/collective" },
    },
  ],
};

export const homePageV2Stories = {
  cards: [
    { title: "Article for Moms in the thick of it", action: "Read", image: IMG.storyAlt, to: "/twentytwentysix/resources" },
    { title: "Connect with local moms in your area", action: "Events", image: IMG.story, to: "/twentytwentysix/events" },
    { title: "Virtual community of moms available 24/7", action: "Chats", image: IMG.story, to: "/twentytwentysix/resources" },
    { title: "Podcasts with inspiring entrepreneurs.", action: "Listen", image: IMG.story, to: "/twentytwentysix/podcasts" },
    { title: "The Mamahood podcast", action: "Listen", image: IMG.story, to: "/twentytwentysix/podcasts" },
    { title: "Grow your business with The Mamahood Collective", action: "Join", image: IMG.story, to: "/twentytwentysix/collective" },
  ],
  link: { label: "All Resources", to: "/twentytwentysix/resources" },
};

export const homePageV2EventsNow = {
  cards: [
    { title: "Virtual Events", text: "Stay connected with other moms from home", image: IMG.story, to: "/twentytwentysix/events" },
    { title: "Local Gatherings", text: "Connect with local moms in your area", image: IMG.story, to: "/twentytwentysix/events" },
    { title: "Moving Together", text: "Initiatives for yourself, family and community", image: IMG.story, to: "/twentytwentysix/programs" },
  ],
  link: { label: "All Events", to: "/twentytwentysix/events" },
};

export const homePageV2Programs = {
  items: [
    {
      title: "Moving in Motion",
      subtitle: "A social impact series centered around the Bay Area community",
      image: IMG.story,
      theme: "mustard",
      imagePosition: "50% 32%",
      imageScale: 1.12,
      to: "/twentytwentysix/programs",
    },
    {
      title: "Mamahood Experiences",
      subtitle: "Explore our programs to get and give support with other mamas",
      image: IMG.event,
      theme: "coral",
      imagePosition: "50% 38%",
      imageScale: 1.08,
      to: "/twentytwentysix/programs",
    },
    {
      title: "Yoga For Moms",
      subtitle: "Yoga series in Walnut Creek running through March and April 2026",
      image: IMG.program,
      theme: "pink",
      imagePosition: "50% 70%",
      imageScale: 1.06,
      to: "/twentytwentysix/programs",
    },
  ],
  link: { label: "All Programs", to: "/twentytwentysix/programs" },
};

export const homePageV2Testimonials = {
  items: [
    {
      quote: "The Mamahood is my go-to for anything kid or mothering-related.",
      body:
        "I've had so many moments of doubt and a simple post and the positive support I get, makes being a mom so much more doable.",
      author: "Sophia Amazingmama",
      meta: "Mom of 2",
      image: IMG.story,
      theme: "teal",
      reverse: false,
      imagePosition: "48% 42%",
      imageScale: 1.02,
    },
    {
      quote: "The Mamahood is so inclusive and loving which means everything.",
      body:
        "I've had so many moments of doubt and a simple post and the positive support I get, makes being a mom so much more doable.",
      author: "Sophia Amazingmama",
      meta: "Mom of 2",
      image: IMG.story,
      theme: "mustard",
      reverse: true,
    },
    {
      quote: "I just can't say enough about how much happier I am with this community.",
      body:
        "I've had so many moments of doubt and a simple post and the positive support I get, makes being a mom so much more doable.",
      author: "Sophia Amazingmama",
      meta: "Mom of 2",
      image: IMG.story,
      theme: "coral",
      reverse: false,
    },
  ],
  link: { label: "More Reviews", to: "/twentytwentysix/reviews" },
};

export const homePageV2MList = {
  bannerImage: IMG.mlistBanner,
  categories: [
    {
      title: "New Moms",
      image: IMG.story,
      ctas: ["Expecting & New Moms", "Parenting", "Philanthropy"],
      to: "/twentytwentysix/mlist",
    },
    {
      title: "Health & Wellness",
      image: IMG.story,
      ctas: ["Health & Wellness", "Money & Career", "Classes & Workshops"],
      to: "/twentytwentysix/mlist",
    },
    {
      title: "Money & Career",
      image: IMG.story,
      ctas: ["Just For Moms", "Lifestyle / Travel", "Marriage Counseling"],
      to: "/twentytwentysix/mlist",
    },
  ],
};

export const homePageV2Collective = {
  headline: "Join 800+ Women Entrepreneurs Building Sustainable Businesses",
  body:
    "For mom founders, entrepreneurs, creatives, and leaders, a private collective for women+ founders, creatives, and service providers in the Bay Area.",
  cta: { label: "Find out more", to: "/twentytwentysix/collective" },
  quote: {
    text: "...a game changer...",
    attribution: "Sarah Johnson, entrepreneur, founder of Cotton & Lace",
  },
  founder: {
    brand: "LOVELY",
    name: "Abby Gale",
    bio: "Founder & CEO of Lovely Clothing Co. Collective Member since 2014",
    note: "Read article featuring Abby in Fashion Mag Zine issue Sept 2025",
    image: IMG.founderFeatured,
    to: "/twentytwentysix/collective",
  },
  link: { label: "Become a Member", to: "/twentytwentysix/join" },
};

export const homePageV2About = {
  founder: {
    name: "Heather Anderson",
    role: "Founder, The Mamahood",
    image: IMG.founderAbout,
  },
  paragraphs: [
    "The Mamahood is the largest, most diverse, support community for over 100,000 mothers in CA, with chapters in the Bay Area, Sacramento Valley, and LA County.",
    "We are an inclusive, social justice focused community, providing empathy, resources, and inspiration to mothers and non-binary parents of all ages and stages of life.",
    "Heather Anderson, Marketing and Brand Strategist, Founder of The Mamahood and The Mamahood Collective, lives for business launches, startups and phrases like \"user acquisition,\" \"strategic partnership\" and \"engagement.\"",
  ],
  regions: [
    { label: "San Francisco Bay Area", to: "/twentytwentysix/events" },
    { label: "Sacramento Valley", to: "/twentytwentysix/events" },
    { label: "LA County", to: "/twentytwentysix/events" },
  ],
};

export const homePageV2Footer = {
  links: [
    { label: "Contact", to: "/twentytwentysix/contact" },
    { label: "Resources", to: "/twentytwentysix/resources" },
    { label: "Podcasts", to: "/twentytwentysix/podcasts" },
    { label: "Events", to: "/twentytwentysix/events" },
    { label: "Membership", to: "/twentytwentysix/membership" },
    { label: "Member Sign-In", to: "/twentytwentysix/login" },
  ],
};
